<template>
    <div>
        <el-dialog
            title="银行商户认证"
            center
            :before-close="()=>{ qrVal = '';dialogVisible=false }"
            width="400px"
            :visible.sync="dialogVisible">
            <div class="a-flex-ccc a-mtb-20">
                <div class="dev-qrcode" id="dev-qrcode"></div>
                <span class="a-fs-14 a-c-master a-mt-18" style="text-align:center">请用微信扫描二维码，前往毛豆充商户端<br>小程序完成认证</span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                dialogVisible: false,
                qrVal: ''
            }
        },
        watch:{
            qrVal:{
                immediate:true,
                handler (val) {
                    if (!val) return
                    this.dialogVisible = true
                    this.$nextTick(()=>{
                        jQuery('#dev-qrcode').html('')
                        jQuery('#dev-qrcode').qrcode({
                            render: "canvas",
                            text: val,
                            width: 148,
                            height: 148,
                            background: "#ffffff",//背景颜色  
                            foreground: "#000000", //前景颜色
                        });
                    })
                    
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .dev-qrcode{
        width: 148px;
        height: 148px;
    }
</style>